export default {"src":"/_next/static/media/academy-icon.c5c63393.svg","height":16,"width":16};